import type { ArtviseCaseFormData } from '../../types/ArtviseCaseTypes';

const baseUrl = '/api/artvisecase';

export const submitCase = async (data: ArtviseCaseFormData): Promise<{ success: boolean; message?: string }> => {
  try {
    const response = await fetch(`${baseUrl}/submit`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      return await response.json();
    }

    const error = await response.json().catch(() => ({ message: 'Submission failed' }));
    return {
      success: false,
      message: error.message || `Server returned ${response.status}`,
    };
  } catch (error) {
    console.error('Artvise case submission error:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Network error occurred',
    };
  }
};
